import type { SVGProps } from 'react';

interface Props extends SVGProps<SVGSVGElement> {
  shieldClassName?: string;
}

export const GlobeWithShield = ({ shieldClassName, ...props }: Props) => (
  <svg fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillOpacity=".5"
      d="M12 1.998c5.487 0 9.942 4.419 10.001 9.892a5.994 5.994 0 0 1-1.526-.566 8.49 8.49 0 0 0-.21-1.326h-1.941a1.6 1.6 0 0 0-.649 0l-.768.001.032.369a7.996 7.996 0 0 1-1.448.974 18.68 18.68 0 0 0-.094-1.343H8.603a19 19 0 0 0 .135 5H12v1.5H9.061c.652 2.415 1.786 4.002 2.94 4.002.276-.001.549-.089.818-.263a6.996 6.996 0 0 0 1.197 1.56c-.652.134-1.324.202-2.016.203-5.524 0-10-4.478-10-10.001C1.999 6.476 6.476 1.998 12 1.998ZM7.508 16.5H4.786a8.53 8.53 0 0 0 4.094 3.41c-.522-.82-.953-1.846-1.27-3.015l-.102-.395ZM7.094 10H3.736l-.005.016A8.5 8.5 0 0 0 3.5 12a8.5 8.5 0 0 0 .544 3h3.173A20 20 0 0 1 7 12c0-.684.031-1.354.094-2Zm1.788-5.91-.023.007A8.53 8.53 0 0 0 4.25 8.5h3.048c.314-1.752.86-3.278 1.583-4.41m3.12-.59-.117.004C10.62 3.62 9.397 5.621 8.83 8.5h6.342c-.566-2.87-1.783-4.869-3.045-4.995l-.126-.006Zm3.12.59.106.174c.67 1.112 1.177 2.572 1.475 4.237h3.048a8.53 8.53 0 0 0-4.339-4.29l-.29-.122Zm7.38 8.887c-1.908-.172-3.435-1.286-4.116-1.87a.6.6 0 0 0-.77 0c-.681.584-2.209 1.698-4.115 1.87a.54.54 0 0 0-.5.523V17c0 4.223 4.094 5.716 4.873 5.962a.419.419 0 0 0 .255 0C18.907 22.715 23 21.221 23 17v-3.5a.54.54 0 0 0-.499-.523Z"
    />
    <path
      className={shieldClassName}
      fillRule="evenodd"
      d="M18.385 11.107c.681.584 2.208 1.698 4.116 1.87A.537.537 0 0 1 23 13.5V17c0 4.221-4.093 5.715-4.872 5.962a.42.42 0 0 1-.255 0C17.094 22.716 13 21.223 13 17v-3.5a.54.54 0 0 1 .5-.523c1.906-.172 3.434-1.286 4.115-1.87a.6.6 0 0 1 .77 0Z"
      clipRule="evenodd"
    />
  </svg>
);
